import LayerGroup from "ol/layer/Group";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import GeoJSON from "ol/format/GeoJSON";

import { getBasicObjectTypeLayer } from "../layers";
import { Geometry } from "ol/geom";
import { buildStyle } from "./buildStyle";

function buildGeoJsonLayer(cfg: any) {
    const source = new VectorSource<Geometry>({
        url: cfg.url,
        format: new GeoJSON({ dataProjection: "EPSG:4326" })
    });

    if (cfg.data) {
        source.addFeatures(
            new GeoJSON().readFeatures(cfg.data, {
                dataProjection: "EPSG:4326",
                featureProjection: "EPSG:3857"
            })
        );
    }

    const layer = new VectorLayer<VectorSource<Geometry>>({
        source
    });

    if (cfg.style) {
        layer.setStyle(buildStyle(cfg.style));
    }
    return layer;
}

function isLayerVisible(
    cfg: any,
    visFilterName: string | undefined,
    visValues: Record<string, unknown> | undefined,
    visIgnored: boolean | undefined
) {
    if (!visFilterName || !cfg.id) return true;
    return visValues?.[cfg.id] || visIgnored;
}

export function buildAdditionalMapFilteredLayer(
    menuItem: any,
    appliedFilters: any = {},
    mapsFiltersExpressions: any = {},
    currentConfig?: any
) {
    if (!menuItem) return undefined;

    const { wmsServer, wmsVersion, workspace } = currentConfig ?? {};
    const { mapLayer } = menuItem;
    if (!mapLayer) return undefined;

    if (!Array.isArray(mapLayer)) {
        const { sourceType } = mapLayer;
        if (!sourceType) {
            console.error("mapLayer: обязательно укажите sourceType", mapLayer);
            return undefined;
        }

        switch (sourceType.toUpperCase()) {
            case "WMS":
                return getBasicObjectTypeLayer(
                    [mapLayer.name],
                    wmsServer,
                    wmsVersion,
                    workspace,
                    "INCLUDE",
                    mapLayer.style
                );

            case "GEOJSON":
                return buildGeoJsonLayer(mapLayer);

            default:
                console.error("Неизвестный sourceType:", sourceType, mapLayer);
                return undefined;
        }
    }

    const wmsNames: string[] = [];
    const wmsFilters: string[] = [];
    const wmsStyles: (string | null)[] = [];
    const vectorLayers: VectorLayer[] = [];

    const [visName, visFilter]: any =
        Object.entries(appliedFilters).find(([, f]: any) => f.type === "layer") ?? [];

    const visValues = visFilter?.appliedValues;
    const visIgnored = visFilter?.isIgnored;

    mapLayer.forEach((cfg: any) => {
        if (!cfg.sourceType) {
            console.error("mapLayer: не указан sourceType", cfg);
            return;
        }

        if (!isLayerVisible(cfg, visName, visValues, visIgnored)) return;

        switch (cfg.sourceType.toUpperCase()) {
            case "WMS": {
                let dynFilter = "";

                if (cfg.applicableFilters && mapsFiltersExpressions) {
                    dynFilter = Object.entries(mapsFiltersExpressions)
                        .filter(([field]) => cfg.applicableFilters.includes(field))
                        .map(([, expr]) => expr)
                        .join(" and ");
                } else if (mapsFiltersExpressions) {
                    dynFilter = Object.values(mapsFiltersExpressions).join(" and ");
                }
                if (cfg.staticFilter) {
                    dynFilter += (dynFilter ? " and " : "") + cfg.staticFilter;
                }

                wmsNames.push(cfg.name);
                wmsFilters.push(dynFilter || "INCLUDE");
                wmsStyles.push(cfg.style ?? null);
                break;
            }

            case "GEOJSON":
                vectorLayers.push(buildGeoJsonLayer(cfg));
                break;

            default:
                console.error("Неизвестный sourceType:", cfg.sourceType, cfg);
        }
    });

    if (!wmsNames.length && !vectorLayers.length) return undefined;

    const layers: any[] = [];

    if (wmsNames.length) {
        layers.push(
            getBasicObjectTypeLayer(
                wmsNames,
                wmsServer,
                wmsVersion,
                workspace,
                wmsFilters.join(";"),
                wmsStyles.some(s => s) ? wmsStyles.join(",") : undefined
            )
        );
    }
    if (vectorLayers.length) layers.push(...vectorLayers);

    return layers.length === 1 ? layers[0] : new LayerGroup({ layers });
}